// Fields from the supplied Lookup Controller collection; Enerex identifier is intentionally omitted.
const columns = [
    { accessorKey: 'name', header: 'Name', meta: { sortBy: 'Name' }, cell: ({ getValue }) => getValue() ?? '—' },
];

export default columns;
